"use client"

import { useEffect, useState } from "react"

const NAMES = ["Vinicius", "Estevão", "Jadson"]

/**
 * Componente de botão de suporte tipo "Floating Card".
 * Design premium com lógica de horário e atendente.
 */
export const WhatsappSupportButton = () => {
  const [config, setConfig] = useState<{
    label: string
    mainText: string
    isOnline: boolean
    color: string
  } | null>(null)

  useEffect(() => {
    const hour = new Date().getHours()
    
    // Lógica de horários
    if (hour >= 22 || hour < 8) {
      // Após as 22h e antes das 8h: Offline
      setConfig({
        label: "Suporte Offline",
        mainText: "(Suporte será respondido amanhã)",
        isOnline: false,
        color: "text-muted-foreground",
      })
    } else if (hour >= 18 && hour < 22) {
      // Entre 18h e 22h: Renan Online
      setConfig({
        label: "Suporte Online",
        mainText: "Falar com Renan",
        isOnline: true,
        color: "text-[#25D366]",
      })
    } else {
      // Horário comercial (08h - 18h): Aleatorização entre os 3 nomes
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
      setConfig({
        label: "Suporte Online",
        mainText: `Falar com ${randomName}`,
        isOnline: true,
        color: "text-[#25D366]",
      })
    }
  }, [])

  if (!config) return null

  const handleSupportClick = () => {
    window.open("https://wa.me/+551142101312", "_blank", "noopener,noreferrer")
  }

  return (
    <button
      onClick={handleSupportClick}
      className="fixed bottom-6 right-6 z-[100] group flex items-center gap-2.5 rounded-2xl border border-gray-200 bg-white/80 p-2.5 backdrop-blur-md transition-all hover:-translate-y-1 hover:bg-gray-50 active:scale-95 shadow-lg"
      aria-label={config.mainText}
    >
      {/* Container do Ícone com indicador de status */}
      <div className={`relative flex h-9 w-9 items-center justify-center rounded-xl ${config.isOnline ? 'bg-[#25D366]/10 text-[#25D366]' : 'bg-gray-100 text-gray-400'}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="h-5 w-5"
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.433 5.631 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
        {/* Pingo de Status */}
        <span className="absolute -right-0.5 -top-0.5 flex h-2.5 w-2.5">
          {config.isOnline && (
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-75"></span>
          )}
          <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${config.isOnline ? 'bg-[#25D366]' : 'bg-gray-400'}`}></span>
        </span>
      </div>

      {/* Textos */}
      <div className="flex flex-col items-start text-left">
        <span className="text-[9px] font-bold uppercase tracking-wider text-gray-400 leading-none">
          {config.label}
        </span>
        <span className="text-xs font-semibold text-gray-900 leading-normal">
          {config.isOnline && !config.mainText.includes("Online") ? "Falar com " : ""}
          <span className={config.isOnline ? "text-[#25D366]" : ""}>
            {config.mainText.replace("Falar com ", "")}
          </span>
        </span>
      </div>
    </button>
  )
}
